'use strict';

/** @DashDialogsStore */
const DashDialogsStore = function (
  $http,
  APP_DISPATCHER_ID,
  Flux,
  IdentityService,
  DashDialogsActions,
  SiteSelectorActions
) {

  //Store init
  const DashDialogsStore = Flux.Store.create({
    name: 'DashDialogsStore',
    events: {
      Changed: true,
      SubscriptionExpired: true,
      OpenDialog: true
    }
  });

  const store = DashDialogsStore;

  //Null initial state
  DashDialogsStore.$state = {
    user: null,
    view: null,
    siteSlugChanged: null
  };

  /**
   * Constructor function that binds to the interaction Flux.Action Signal from the component
   */
  DashDialogsStore.init = () => {

    const dispatcher = Flux.Dispatcher.get(APP_DISPATCHER_ID);

    dispatcher.register(DashDialogsActions.SubscriptionExpired, store._handleSubscriptionExpired.bind(store));
    dispatcher.register(DashDialogsActions.NoDataCaptureAvailable, store._handleNoDataCaptureAvailable.bind(store));
    dispatcher.register(DashDialogsActions.NotSupportedInPlanWarning, store._handleNotSupportedInPlanWarning.bind(store));
    dispatcher.register(DashDialogsActions.SiteSlugChanged, store._handleSiteSlugChanged.bind(store));
    dispatcher.register(DashDialogsActions.SiteDeleted, store._handleSiteDeleted.bind(store));
  };

  // Handlers //////////////////////////////////////////////////////////////////

  store._handleSubscriptionExpired = (payload) => {

    DashDialogsStore.$set('view', 'subscriptionExpired');
    DashDialogsStore.emit(DashDialogsStore.Events.OpenDialog);
  };

  store._handleNoDataCaptureAvailable = () => {

    DashDialogsStore.$set('view', 'noDataCaptureAvailable');
    DashDialogsStore.emit(DashDialogsStore.Events.OpenDialog);
  };

  store._handleNotSupportedInPlanWarning = () => {

    DashDialogsStore.$set('view', 'notSupportedPlanFeatureWarning');
    DashDialogsStore.emit(DashDialogsStore.Events.OpenDialog);
  };

  store._handleSiteSlugChanged = (data) => {

    DashDialogsStore.$set('view', 'siteSlugChanged');
    DashDialogsStore.$set('siteSlugChanged', data.site);
    SiteSelectorActions.HideSiteSelector.dispatch();
    DashDialogsStore.emit(DashDialogsStore.Events.OpenDialog);
  }

  store._handleSiteDeleted = () => {

    DashDialogsStore.$set('view', 'siteDeleted');
    SiteSelectorActions.HideSiteSelector.dispatch();
    DashDialogsStore.emit(DashDialogsStore.Events.OpenDialog);
  }

  return DashDialogsStore;
};

DashDialogsStore.$inject = [
  '$http',
  'APP_DISPATCHER_ID',
  'sbFlux',
  'IdentityService',
  'DashDialogsActions',
  'SiteSelectorActions'
];
module.exports = DashDialogsStore;


// WEBPACK FOOTER //
// ./src/app/dash/dialogs/DashDialogsStore.js